exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-game {\n  margin: 100px auto;\n  display: block;\n  max-width: 700px;\n  padding: 20px 40px;\n  font-family: sans-serif;\n  color: #595959; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/mobx-tic-tac.component.scss
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/mobx-tic-tac.component.scss
// module chunks = main